import * as swcHelpers from '@swc/helpers';

const createProductLookup = (productProjections)=>{
    let product = {};
    let variant = {};
    productProjections.forEach((p)=>{
        const variants = [
            p.masterVariant,
            ...p.variants
        ];
        variants.forEach((v)=>{
            if (v.sku) {
                product = swcHelpers.objectSpread({}, product, {
                    [v.sku]: p
                });
                variant = swcHelpers.objectSpread({}, variant, {
                    [v.sku]: v
                });
            }
        });
    });
    return {
        product,
        variant
    };
};

export { createProductLookup };
//# sourceMappingURL=create-product-lookup.js.map
